// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3YPvl","inner":"Footer_inner__1OCQy","nextIcon":"Footer_nextIcon__2jCGX","innerLeft":"Footer_innerLeft__3k-9a"};